import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../../assets/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    selectWrapper: {
      border: `1px solid ${Colors.Gray2}`,
      backgroundColor: Colors.White,
      borderRadius: '4px',
      height: '50px !important',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 17,
      marginTop:'16px'
    },
    selectIcon: {
      marginRight: 10,
    },
    label: {
      fontSize: 16,
      color: Colors.Blue1,
      fontWeight: FontWeight.Bold,
    },
    labelError: {
      color: Colors.Red,
    },
    placeholder: {
      color: Colors.Gray,
    },
    inputError: {
      borderColor: Colors.Red,
    },
    error: {
      fontWeight: FontWeight.Regular,
      fontSize: 14,
    },
    text: {
      marginTop: 20,
    },
  };
});

export default useStyles;